import customAxios from "./axiosConfig";

const CompanySettingService = {
  update: function (data) {
    const config = {
      headers: { 'content-type': 'application/json;charset=UTF-8' },
    };
    return customAxios.put(window.Urls["company_settings_detail"](data.id), data, config);
  },
  retrieve(params) {
    const api_url = '/api/v2/company-settings/'
    return customAxios.get(api_url, { params: params });
  },
  list(params) {
    const api_url = window.Urls['company_settings_list']();
    return customAxios.get(api_url, { params: params });
  },
  partialUpdate(id, data) {
    const api_url = window.Urls['company_settings_detail'](id);
    return customAxios.patch(api_url, data);
  }
};

export default CompanySettingService;